module.exports = __webpack_public_path__ + "img/search.fd9b8d90.svg";